import { useMemo, useState } from 'react';
import type { TakeoverNavGroup } from './TakeoverNav';

/** Case-insensitive filter shared by every takeover nav. Matches label,
 *  description, and features so parent items surface when users search for
 *  a child concept (e.g. "secrets" matches the Credentials row). */
export function useTakeoverNavSearch(): {
  query: string;
  setQuery: (q: string) => void;
  filterGroups: (groups: TakeoverNavGroup[]) => TakeoverNavGroup[];
} {
  const [query, setQuery] = useState('');
  const filterGroups = useMemo(() => {
    const q = query.trim().toLowerCase();
    return (groups: TakeoverNavGroup[]) => {
      if (!q) return groups;
      return groups
        .map((group) => ({
          ...group,
          items: group.items.filter((item) => {
            if (item.label.toLowerCase().includes(q)) return true;
            if (item.description?.toLowerCase().includes(q)) return true;
            if (item.features?.some((f) => f.toLowerCase().includes(q))) return true;
            return false;
          }),
        }))
        .filter((group) => group.items.length > 0);
    };
  }, [query]);
  return { query, setQuery, filterGroups };
}
